import NotFoundView from './components/404.vue'
import LoginView from './components/Login.vue'
import Home from './components/Home.vue'

import TripRequest from './components/Trip/TripRequest.vue'
import TripList from './components/Trip/TripList.vue'

//Driver
import Driver from './components/Driver/Driver.vue'
import DriverList from './components/Driver/DriverList.vue'
import DriverEdit from './components/Driver/DriverEdit.vue'
import DriverDelete from './components/Driver/DriverDelete.vue'

//Device
import Device from './components/Device/Device.vue'
import DeviceList from './components/Device/DeviceList.vue'
import DeviceView from './components/Device/DeviceView.vue'
import DeviceDelete from './components/Device/DeviceDelete.vue'

import TripTimeline from './components/Trip/TripTimeline.vue'

// Import Views - TripRequest

// Routes

const routes = [
  {
    path: '/login',
    name: 'login',
    component: LoginView,
  },
  {
    path: '/',
    component: Home,
    children: [
      {
        path: '',
        component: TripList,
        name: 'Trip List',
        meta: { auth: true },
        description: 'All Trip Request'
      },{
        path: '/triptimeline/:id',
        component: TripTimeline,
        name: 'Trip Timeline',
        meta: { auth: true },
        description: 'All Trip Request'
      },
      {
        path: '/driver',
        component: Driver,
        children: [
          {
            path: '',
            component: DriverList,
            name: 'Driver List',
            meta: { auth: true },
            description: 'Overview of environment'
          },{
            path: '/driver/:fbid',
            component: DriverEdit,
            name: 'Driver Edit',
            meta: { auth: true },
            description: 'Update Driver'
          },{
            path: '/driverdelete/:fbid',
            component: DriverDelete,
            name: 'Driver Delete',
            meta: { auth: true },
            description: 'Delete Driver'
          }
        ]
      },
      {
        path: '/device',
        component: Device,
        children: [
          {
            path: '',
            component: DeviceList,
            name: 'Device List',
            meta: { auth: true },
            description: 'Overview of environment'
          },{
            path: '/device/:iid',
            component: DeviceView,
            name: 'Device Information',
            meta: { auth: true },
            description: 'View Device'
          }
        ]
      },
      {
        path: '/triprequest/:sender',
        component: TripRequest,
        name: 'Trip Request',
        meta: { auth: true },
        description: 'Admin Trip Request'
      }
    ]
  },{
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js